module.exports = __webpack_public_path__ + "img/picture_slt02.94b05f0a.png";